import { isEditingBuilderDoc } from '~/../components/builder/editor/helpers'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['themeOption']
  static values = { setting: String }

  connect() {
    this.settingValue = this.settingValue || 'theme'
  }

  // Do this when option target first connects cause we may be in a lazy dropdown
  themeOptionTargetConnected() {
    if (this._selectedUpdated || isEditingBuilderDoc()) return
    this._selectedUpdated = true
    setTimeout(() => this.updateSelected(), 0)
  }

  changeTheme(e) {
    const theme = e.currentTarget.dataset.theme
    UserPreference.set(this.settingValue, theme)

    const tempStylesheet = document.createElement('style')
    tempStylesheet.innerHTML = '* { transition: none !important };'
    document.body.appendChild(tempStylesheet)
    this.updateSelected()
    void document.body.offsetWidth
    tempStylesheet.remove()
  }

  updateSelected() {
    // This is defined in the head tag through _theme_from_user_preference.html.erb. It's inlined to prevent FOUC during initial page render.
    // It also dispatches 'theme-changed' when the resolved theme actually changes.
    window.setDarkClassBasedOnUserPreference?.()

    const theme =
      UserPreference.get(this.settingValue) ||
      localStorage.getItem(this.settingValue) ||
      window.defaultColorScheme ||
      'system'
    this.themeOptionTargets.forEach((option) => {
      option
        .querySelector('.js-theme-active-icon')
        .classList.toggle('is-active', option.dataset.theme === theme)
    })
  }
}
